<template>
    <div>
        <!-- Table Top Start -->
        <div class="d-flex mt-3" style="align-items:center;">
            <div style="flex-grow:1;" class="pl-2">
            </div>
            <div class="form-group form-inline pr-2">
                <span class="mr-1">Show </span>
                <select v-model="PageSize" class="form-control">
                    <option :value="5">5</option>
                    <option :value="10">10</option>
                    <option :value="15">15</option>
                </select>
                <span class="ml-1"> entries</span>
            </div>
        </div>
        <div class="spinner-border" v-if="showLoader"></div>
        <!-- Table Top End -->
        <!--  Table Start -->
        <table class="table table-hover table-striped mb-2" v-else>
            <thead>
            <tr>
                <th style="width: 10%;">Code</th>
                <th style="width: 10%;">User Name</th>
                <th style="width: 10%;">Value</th>
                <th style="width: 10%;">Order Number</th>
                <th style="width: 10%;">Expiried On</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="breakgeTransaction in breakageHistory" :key="breakgeTransaction.id">
                <td>{{ breakgeTransaction.code }}</td>
                <td>{{ breakgeTransaction.user_name }} <br> {{ breakgeTransaction.user_email }}</td>
                <td>{{ breakgeTransaction.currency }} {{ breakgeTransaction.value }}</td>
                <td>{{ breakgeTransaction.order_id }}</td>
                <td>{{ breakgeTransaction.expiration_ts }}</td>
            </tr>
            </tbody>
        </table>
        <!--  Table End -->
        <!-- Page Number Start -->
        <div class="d-flex mb-2" style="align-items: center;">
            <div style="flex-grow: 1;" class="pl-2">
            <p>
                Showing {{ (PageNumber - 1) * PageSize + 1 }} to {{ UpperLimit }}
                of {{ TotalRecords }} entries
            </p>
            </div>
            <div class="pr-2">
            <Pagination
            :data="breakageHistory"
            :totalPages="Math.ceil(TotalRecords / PageSize)"
            :total="TotalRecords"
            :perPage="PageSize"
            :currentPage="PageNumber"
            @pagechanged="onTablePageChange"
            />
            </div>
        </div>
        <!-- Page Number End-->
    </div>
</template>

<script>
import DashboardService from "../services/DashboardService"
import Pagination from "../components/Pagination.vue";
export default {
  name: 'BreakageTransactionHistory',
  components: {
    Pagination,
  },
  props: {
    dateType: String
  },
  data() {
    return {
        PageSize: 5,
        PageNumber: 1,
        TotalRecords: 0,
        UpperLimit:0,
        breakageHistory:[],
        showLoader: false,
    }
  },
  methods: {
    getBreakageTransactionHistory() {
      this.showLoader = true;
      let data = { dateType: this.dateType, pageSize: this.PageSize, page: this.PageNumber }
      DashboardService.getBreakageTransactionHistory(data)
        .then((response) => {
          this.showLoader = false;
          this.breakageHistory = response.data.data.data;
          this.TotalRecords = response.data.data.total;
          this.UpperLimit = this.TotalRecords < this.PageNumber * this.PageSize ? this.TotalRecords : this.PageNumber * this.PageSize;
        })
        .catch((e) => {
          this.showLoader = false;
        });
    },
    onTablePageChange(page) {
      this.PageNumber = page;
      try {
        this.getBreakageTransactionHistory();
      } catch (error) {
        console.log(error);
      }
      window.scrollTo(0, 0);
    },
  },
  watch: {
    PageSize() {
      this.PageNumber = 1;
      this.getBreakageTransactionHistory();
    },
    dateType() {
        this.getBreakageTransactionHistory();
    }
  },
  beforeMount() {
    this.getBreakageTransactionHistory();
  },
}
</script>
